import type { DashboardKey } from '../../request/dashboards/layout.ts';

/** Query key registry for the per-user dashboard widget selection. */
const dashboardsRoot = ['dashboards'] as const;

export const dashboardLayoutQueryKeys = {
  all: dashboardsRoot,
  layout: (key: DashboardKey) => [...dashboardsRoot, key, 'layout'] as const,
} as const;
